module.exports = __webpack_public_path__ + "media/images/new_landing/people/filip-fabisik-e6b16616a73d5f5b2c75910992840602.jpeg";